import { defineMessages } from 'react-intl';

export const messages: {
	teamLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	avatarLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	teamLabel: {
		id: 'team',
		defaultMessage: 'Team',
		description:
			'Accessible label for a team entry shown in the people-and-teams dropdown on the search page.',
	},
	avatarLabel: {
		id: 'avatar',
		defaultMessage: 'Avatar',
		description:
			'Accessible label for the avatar image of a person or team shown in the people-and-teams search dropdown.',
	},
});
